module.exports = __webpack_public_path__ + "img/img_index_thumb_company_intro.44b165ea.jpg";